export default __webpack_public_path__ + "static/media/clock-icon.a83e8663.svg";